'use client'
import { Jumbotron as JumbotronData } from '@/payload-types'
import { formatDate } from '@/lib/postFunctions'
import { JumbotronContainer } from './jumbotronContainer'
import { JumbotronContent } from './jumbotronContent'

interface IProps {
  jumbotronData?: JumbotronData
  rounded?: boolean
  publish?: string
}
export interface JumbotronStyle {
  backgroundColor?: string | null
  title?: {
    color?: string | null
  }
  subTitle?: {
    color?: string | null
  }
}

export const Jumbotron = ({ jumbotronData, rounded, publish }: IProps) => {
  const jumbotron = jumbotronData
  const jumbotronStyle = jumbotronData?.styling as JumbotronStyle

  const desktopImageUrl =
    typeof jumbotron?.media?.media === 'object'
      ? jumbotron.media.media?.sizes?.large?.url?.replace(/ /g, '%20')
      : ''

  const mobileImageUrl =
    typeof jumbotron?.media?.mobileMedia === 'object'
      ? jumbotron.media.mobileMedia?.sizes?.large?.url?.replace(/ /g, '%20')
      : ''

  const baseUrl = process.env.NEXT_PUBLIC_PAYLOAD_URL || ''
  const isObject = typeof jumbotron?.media?.media === 'object'

  const desktopBackgroundImage = isObject ? `${baseUrl}${desktopImageUrl}` : ''
  const mobileBackgroundImage = isObject ? `${baseUrl}${mobileImageUrl || desktopImageUrl}` : ''

  return (
    <section>
      <JumbotronContainer
        isMobile={false}
        backgroundImage={desktopBackgroundImage}
        jumbotronStyle={jumbotronStyle}
        rounded={rounded}
      >
        <JumbotronContent jumbotron={jumbotron} jumbotronStyle={jumbotronStyle} />
        {publish && (
          <div
            className={`text-${jumbotronStyle?.subTitle?.color} text-center md:my-4 font-semibold text-[16px]`}
          >
            {formatDate(publish)}
          </div>
        )}
      </JumbotronContainer>
      <JumbotronContainer
        isMobile={true}
        backgroundImage={mobileBackgroundImage}
        jumbotronStyle={jumbotronStyle}
        rounded={rounded}
      >
        <JumbotronContent jumbotron={jumbotron} jumbotronStyle={jumbotronStyle} />
        {publish && (
          <div
            className={`text-${jumbotronStyle?.subTitle?.color} text-center md:my-4 font-semibold text-[16px]`}
          >
            {formatDate(publish)}
          </div>
        )}
      </JumbotronContainer>
    </section>
  )
}

export default Jumbotron
